import { useEffect, useMemo, useState } from "react";
import { getTimeSeries } from "pages/api-clients/graph-search";
import { TimeUnit } from "pages/[orgId]/explore/lib/FormattingControls";
import { useDurationOrDatesToRange } from "src/hooks/useDurationOrDatesToRange";
import { useQuerySubscription } from "src/hooks/useQuerySubscription";
import { idealTimeUnit } from "src/utils/date";
import { useApplicationContext } from "src/hooks/useApplication";
import { useQueryToasterErrors } from "src/hooks/useToaster";
import { SearchState } from "../types";

export function useTimeSeries(props: { state: SearchState }) {
  const orgId = useApplicationContext().org_id!;
  const [preference, setTimeUnit] = useState<TimeUnit>(TimeUnit.AUTO);
  const [start, end] = useDurationOrDatesToRange({
    start: props.state.startDate,
    end: props.state.endDate,
    duration: props.state.duration,
  });

  const autoResetTrigger = `${start}-${end}`;
  useEffect(() => setTimeUnit(TimeUnit.AUTO), [autoResetTrigger]);

  const autoTimeUnit = useMemo(() => idealTimeUnit(start, end), [start, end]);
  const timeUnit = preference === TimeUnit.AUTO ? autoTimeUnit : preference;

  const state: typeof props.state = {
    ...props.state,
    orgId,
    aggregations: [],
    groupBys: undefined,
  };
  const { query, subscribe, unsubscribe } = useQuerySubscription(
    ["search/useTimeSeries", { state, timeUnit: timeUnit }],
    async () => getTimeSeries(state, timeUnit, orgId)
  );

  useQueryToasterErrors(query);

  return {
    ...query,
    preference,
    timeUnit,
    autoTimeUnit,
    setTimeUnit,
    subscribe,
    unsubscribe,
  };
}
